<template>
  <div>
    <el-form ref="advertising-format" :model="form" :rules="rules" label-position="top" label-width="120px">
      <el-form-item prop="video" label="视频文件">
        <el-row>{{ videoMsg }}</el-row>
        <gj-upload-video
          containerType="mailReply"
          :file-list="proxyFileList"
          :form="form"
          :params="videoParams">
        </gj-upload-video>
        <el-popover class="popover-content-ad-sb" placement="right" popper-class="standard-list" title="亚马逊审核标准" width="200" trigger="hover">
          <gj-button type="text" slot="reference">查看亚马逊审核标准</gj-button>
          <div class="popover-main">
            <div class="main-cell" v-for="(item, index) in standardList" :key="index">{{ item }}</div>
          </div>
        </el-popover>
      </el-form-item>
      <el-form-item label="视频文件要求：">
        <el-row v-for="item in specifications" :key="item.title" class="specifications-cell">
          <el-col :span="3">{{ item.title }}</el-col>
          <el-col :span="20">
            <el-row v-for="(detailed, index) in item.list" :key="index" class="detailed-cell">{{ detailed }}</el-row>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import GjUploadVideo from '@/components/upload/gj-upload-video.vue';
export default {
  name: '',
  inject: ['getForms', 'getPublicObj'],
  props: {},
  data() {
    return {
      videoFlag: true,
      videoUploadPercent: 0,
      proxyFileList: [], // 上传的文件列表
      videoMsg: "保持视频简短且相关。视频会自动播放，请确保前2秒非常吸引人，并且不要依靠声音来传达信息。如果在视频中使用文本，请确保文本清晰可辨。字幕或音频必须与广告显示区域的设置相匹配。",
      form: {},
      rules: {
        video: []
      },
      standardList: [
        "视频审核",
        "不得包含促销、折扣或其他关于折扣性质的宣传",
        "行动号召的按钮或文字",
        "意图吸引买家点击或购买的有压迫性、侵犯性或催促性用语",
        "分散注意力的图片（如闪烁、旋转、跳动的对象或文本，或对比强烈的转换）",
      ],
      specifications: [ // 规格
        {
          title: "视频规格",
          list: [
            "16:9宽高比",
            "尺寸：1280*720像素、1920*1080像素或者3840*2160像素",
            "帧率：23.976fps、24fps、25fps、29.97fps、29.98fps 或 30fps",
            "视频比特率：最低 1Mbps",
            "视频编解码器：H.264 或 H.265",
            "视频持续时间：6 至 45 秒",
            "文件大小：小于 500MB",
            "文件格式：MP4 或 MOV",
            "主要规范或基准规范",
            "视频扫描类型：逐行扫描",
            "仅1音频流",
          ]
        },
        {
          title: "音频规格",
          list: [
            "音频采样率：最低 44.1kHz",
            "音频编解码器：PCM、AAC 或 MP3",
            "音频比特率：最低 96kbps",
            "音频格式：立体声或单声道",
            "不超过1音频流",
          ]
        }
      ]
    };
  },
  components: { GjUploadVideo },
  computed: {
    publicObj() {
      return this.getPublicObj()
    },
    videoParams() {
      let params = {
        marketId: this.publicObj.SB.marketId
      }
      return params
    }
  },
  methods: {
    beforeUploadVideo() {
      // this.$message.error('geshi chu li ');
      return true
    },
  },
  created() {
    let { creative } = this.getForms()
    this.form = creative
  },
};
</script>

<style lang='scss'>
.specifications-cell {
  padding-bottom: 10px;
  .detailed-cell {
    position: relative;
    color: #666;
    line-height: 28px;
    &::before {
      content: "";
      width: 8px;
      height: 8px;
      position: absolute;
      top: 50%;
      left: -20px;
      transform: translateY(-50%);
      border-radius: 100%;
      background: #ccc;
    }
  }
}
.standard-list {
  width: 539px !important;
  min-height: 170px !important;
  background: #282828;
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
  border-radius: 4px;
  color: #ddd;
  .el-popover__title {
    font-size: 14px;
    color: #eee;
  }
  .popover-main {
    padding: 0 15px;
    .main-cell {
      font-size: 12px;
      position: relative;
      padding-bottom: 12px;
      &::before {
        content: "";
        position: absolute;
        width: 5px;
        height: 5px;
        background: #999;
        border-radius: 100%;
        top: 6px;
        left: -12px;
      }
    }
  }
  .popper__arrow {
    &::after {
      border-right-color: #282828 !important;
    }
  }
}
.popover-content-ad-sb {
  position: absolute;
  right: 0;
  top: 52px;
}
</style>